// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-admin-modal {
    max-width: 700px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    background: white;
    border-radius: 20px;
    padding: 2rem;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.edit-admin-modal h2 {
    margin: 0;
    color: #1a202c;
}

.form-section {
    margin-top: 2rem;
    padding-bottom: 2rem;
    border-bottom: 1px solid #edf2f7;
}

.form-section h3 {
    font-size: 1.1rem;
    color: #2d3748;
    margin-bottom: 1rem;
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1.5rem;
    gap: 1.5rem;
}

.form-group {
    margin-bottom: 1.25rem;
}

.form-group label {
    display: block;
    font-size: 0.9rem;
    color: #718096;
    margin-bottom: 0.5rem;
}

.form-group input[type="text"],
.form-group input[type="email"],
.form-group select {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 1rem;
    outline: none;
    transition: all 0.2s;
}

.form-group input:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.checkbox-group label {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    color: #2d3748;
    font-weight: 600;
    cursor: pointer;
}

.section-hint {
    font-size: 0.85rem;
    color: #a0aec0;
    margin-bottom: 1.5rem;
}

.permission-category-group {
    margin-bottom: 2rem;
}

.permission-category-group h4 {
    font-size: 0.9rem;
    color: #4a5568;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 1rem;
}

.permission-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-gap: 1rem;
    gap: 1rem;
}

.permission-quick-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    align-items: center;
    margin-bottom: 0.75rem;
}

.pill-btn {
    border: 1px solid #cbd5e0;
    background: #f7fafc;
    color: #1a202c;
    padding: 0.35rem 0.75rem;
    border-radius: 999px;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.2s ease;
}

.pill-btn:hover {
    background: #edf2f7;
    box-shadow: 0 4px 12px rgba(0,0,0,0.06);
}

.pill-btn.ghost {
    background: transparent;
    border: 1px dashed #cbd5e0;
}

.pill-btn-group {
    display: flex;
    gap: 0.35rem;
    flex-wrap: wrap;
    align-items: center;
}

.pill-label {
    font-weight: 600;
    color: #4a5568;
    margin-right: 0.25rem;
}

.category-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    margin-bottom: 0.4rem;
}

.permission-pill {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    background: #f7fafc;
    border: 1px solid #edf2f7;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s;
}

.permission-pill:hover {
    background: #edf2f7;
    border-color: #e2e8f0;
}

.permission-pill.active {
    background: rgba(102, 126, 234, 0.1);
    border-color: #667eea;
    color: #667eea;
}

.p-icon {
    font-size: 1.2rem;
}

.p-label {
    font-size: 0.85rem;
    font-weight: 600;
}

.all-access-alert {
    padding: 1rem;
    background: #fffaf0;
    border: 1px solid #feebc8;
    border-radius: 8px;
    color: #c05621;
    font-size: 0.9rem;
}

.security-section {
    background: #f8fafc;
    border-radius: 12px;
    padding: 1.5rem;
    margin-top: 2rem;
}

.security-notice {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.security-notice p {
    font-size: 0.85rem;
    color: #4a5568;
    margin: 0;
}

.btn-login-shortcut {
    align-self: flex-start;
    background: #4c51bf;
    color: white;
    font-size: 0.9rem;
    padding: 0.6rem 1.2rem;
}

.btn-login-shortcut:hover {
    background: #434190;
    transform: translateY(-2px);
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    padding-top: 2rem;
}

.btn {
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    transition: all 0.2s;
}

.btn-secondary {
    background: #edf2f7;
    color: #4a5568;
}

.btn-primary {
    background: #667eea;
    color: white;
}

.btn-primary:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/EditAdminModal.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAW;IAAX,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,qBAAqB;AACzB;;AAEA;;;IAGI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,cAAS;IAAT,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,wBAAwB;IACxB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".edit-admin-modal {\n    max-width: 700px;\n    width: 90%;\n    max-height: 90vh;\n    overflow-y: auto;\n    background: white;\n    border-radius: 20px;\n    padding: 2rem;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.edit-admin-modal h2 {\n    margin: 0;\n    color: #1a202c;\n}\n\n.form-section {\n    margin-top: 2rem;\n    padding-bottom: 2rem;\n    border-bottom: 1px solid #edf2f7;\n}\n\n.form-section h3 {\n    font-size: 1.1rem;\n    color: #2d3748;\n    margin-bottom: 1rem;\n}\n\n.form-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1.5rem;\n}\n\n.form-group {\n    margin-bottom: 1.25rem;\n}\n\n.form-group label {\n    display: block;\n    font-size: 0.9rem;\n    color: #718096;\n    margin-bottom: 0.5rem;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"email\"],\n.form-group select {\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 1rem;\n    outline: none;\n    transition: all 0.2s;\n}\n\n.form-group input:focus {\n    border-color: #667eea;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.checkbox-group label {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    color: #2d3748;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.section-hint {\n    font-size: 0.85rem;\n    color: #a0aec0;\n    margin-bottom: 1.5rem;\n}\n\n.permission-category-group {\n    margin-bottom: 2rem;\n}\n\n.permission-category-group h4 {\n    font-size: 0.9rem;\n    color: #4a5568;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    margin-bottom: 1rem;\n}\n\n.permission-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 1rem;\n}\n\n.permission-quick-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    align-items: center;\n    margin-bottom: 0.75rem;\n}\n\n.pill-btn {\n    border: 1px solid #cbd5e0;\n    background: #f7fafc;\n    color: #1a202c;\n    padding: 0.35rem 0.75rem;\n    border-radius: 999px;\n    font-size: 0.85rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.pill-btn:hover {\n    background: #edf2f7;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.06);\n}\n\n.pill-btn.ghost {\n    background: transparent;\n    border: 1px dashed #cbd5e0;\n}\n\n.pill-btn-group {\n    display: flex;\n    gap: 0.35rem;\n    flex-wrap: wrap;\n    align-items: center;\n}\n\n.pill-label {\n    font-weight: 600;\n    color: #4a5568;\n    margin-right: 0.25rem;\n}\n\n.category-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.5rem;\n    margin-bottom: 0.4rem;\n}\n\n.permission-pill {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.75rem 1rem;\n    background: #f7fafc;\n    border: 1px solid #edf2f7;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.permission-pill:hover {\n    background: #edf2f7;\n    border-color: #e2e8f0;\n}\n\n.permission-pill.active {\n    background: rgba(102, 126, 234, 0.1);\n    border-color: #667eea;\n    color: #667eea;\n}\n\n.p-icon {\n    font-size: 1.2rem;\n}\n\n.p-label {\n    font-size: 0.85rem;\n    font-weight: 600;\n}\n\n.all-access-alert {\n    padding: 1rem;\n    background: #fffaf0;\n    border: 1px solid #feebc8;\n    border-radius: 8px;\n    color: #c05621;\n    font-size: 0.9rem;\n}\n\n.security-section {\n    background: #f8fafc;\n    border-radius: 12px;\n    padding: 1.5rem;\n    margin-top: 2rem;\n}\n\n.security-notice {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.security-notice p {\n    font-size: 0.85rem;\n    color: #4a5568;\n    margin: 0;\n}\n\n.btn-login-shortcut {\n    align-self: flex-start;\n    background: #4c51bf;\n    color: white;\n    font-size: 0.9rem;\n    padding: 0.6rem 1.2rem;\n}\n\n.btn-login-shortcut:hover {\n    background: #434190;\n    transform: translateY(-2px);\n}\n\n.modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    padding-top: 2rem;\n}\n\n.btn {\n    padding: 0.75rem 1.5rem;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    border: none;\n    transition: all 0.2s;\n}\n\n.btn-secondary {\n    background: #edf2f7;\n    color: #4a5568;\n}\n\n.btn-primary {\n    background: #667eea;\n    color: white;\n}\n\n.btn-primary:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
